// Dependecies
//
var $ = require('jquery');


// Localisation
//
var cookiesUtils = require('cookies-utils');
var localcookie = cookiesUtils.read('localecookie');

if (localcookie == "fr" || localcookie == "fr-ca") {
	require('jquery-validation/dist/localization/messages_fr.js');	
}


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/forms-validation/localization.js
// module id = 256
// module chunks = 0